import { DynamicFormElementValidatorType } from './dynamic-form-element-validator-type.enum';

export class DynamicFormElementValidatorConfig {
  public type!: DynamicFormElementValidatorType;
  public errorMsg?: string;
  public value?: any;
}
